<template>
    <div class="survey-thanks-container">
        <v-row justify="center">
            <v-col align-self="center" cols="12" class="text-center survey-thanks-message" >
                Esta evaluación ya fue completada anteriormente
                <br>
                
                <span  class="caption grey--text clic" @click="returnToMain">Ir al inicio de sesión</span>
            </v-col>
            
        </v-row>
        
        <div>
            
            <img :src="companyLogo" alt="" class="survey-thanks-company">
        </div>
    </div>
   
</template>

<script>
// import image from '../../assets/backgroundLogin.png';
import companyLogo from '../../../assets/LOGO_GRUPO_MERCA.png';

// import VueGatesPlugin from '../plugins/vue-gates';
export default {
  components: {  },
	name: 'EvaluationAlreadyDone',
	data: () => ({
        companyLogo,
		

	}),
	methods: {
		returnToMain()
        {
            if(this.$gates.hasPermission('employee_site.show')){
                this.$router.push({name: 'MyInfo'});
            }else{
                this.$router.push('/login');
            }
        }
        
	}
}
</script>


<style lang="scss">
    
    .survey-thanks{

        &-container{
            display: flex;
            flex-direction: column;
            position: relative;
        }

        &-message{
            font-size: 1.5rem;
            font-weight: 500;
        }
        &-submessage{
            font-size: 1.0rem;
            font-weight: 500;
        }

        &-company{
            // width: 100%;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 60px;
        }
    }
</style>

